import { TTypeOfCodec, TTypeOfNewDefault } from "../../../shared/src/codecs/codec";
import { formEditable, TFormEditableCodec } from "../../../shared/src/codecs/types/formEditable";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string, TAnyStringCodec } from "../../../shared/src/codecs/types/string";
import { TAnyUuidCodec, uuid } from "../../../shared/src/codecs/types/uuid";

const BuyerUpdatesMortgageBrokerDetailsFields = required({
    enquiry_id: uuid(),
    mortgage_broker_organisation_name: string(),
    mortgage_broker_name: string(),
    mortgage_broker_phone_number: string(),
    mortgage_broker_email_address: string(),
});

type TBuyerUpdatesMortgageBrokerDetailsFieldsCodec = TRequiredCodec<{
    enquiry_id: TAnyUuidCodec;
    mortgage_broker_organisation_name: TAnyStringCodec;
    mortgage_broker_name: TAnyStringCodec;
    mortgage_broker_phone_number: TAnyStringCodec;
    mortgage_broker_email_address: TAnyStringCodec;
}>;

export const BuyerUpdatesMortgageBrokerDetailsFormEditable: TFormEditableCodec<TBuyerUpdatesMortgageBrokerDetailsFieldsCodec> = formEditable(BuyerUpdatesMortgageBrokerDetailsFields);

export type TBuyerUpdatesMortgageBrokerDetailsFormEditableCodec = typeof BuyerUpdatesMortgageBrokerDetailsFormEditable;

export type TBuyerUpdatesMortgageBrokerDetailsFormEditable = TTypeOfCodec<TBuyerUpdatesMortgageBrokerDetailsFormEditableCodec>;

export type TBuyerUpdatesMortgageBrokerDetailsFormEditableNewDefault = TTypeOfNewDefault<TBuyerUpdatesMortgageBrokerDetailsFormEditableCodec>;
